import { FC } from "react";
import { Stack } from "@mui/material";
import { DrawerChartHeader } from "../common/data-grid/CommitmentsDrawerChartHeader";
import { CommitmentsDrawerContentInfoCard } from "../common/CommitmentsDrawerContentInfoCard";
import { CommitmentsProgressBar } from "../../common/CommitmentsProgressBar";
import { money } from "../../../../../../../utils/numeral/money";
import { useAppSelector } from "../../../../../../../store/hooks";
import { savingsPlanDetailsMetaDataSelector } from "../../../../../../../store/commitments/selectors/coverage-and-utilization/details-drawer/savings-plan/savingsPlanDetailsMetaDataSelector";
import { utilizationAndCoverageDetailsLoadingSelector } from "../../../../../../../store/commitments/selectors/coverage-and-utilization/details-drawer/data/utilizationAndCoverageDetailsLoadingSelector";

export const SavingsPlanDrawerChartHeader: FC = () => {
  const metadata = useAppSelector(savingsPlanDetailsMetaDataSelector);
  const isLoading = useAppSelector(
    utilizationAndCoverageDetailsLoadingSelector,
  );

  return (
    <DrawerChartHeader>
      <Stack direction="row" flexWrap="wrap" gap={1} mt={3}>
        <CommitmentsDrawerContentInfoCard
          cardSx={cardSx}
          loading={isLoading}
          title="Utilization"
        >
          <CommitmentsProgressBar
            width="100%"
            value={metadata?.utilization ?? 0}
          />
        </CommitmentsDrawerContentInfoCard>

        <CommitmentsDrawerContentInfoCard
          cardSx={cardSx}
          loading={isLoading}
          title="Used Commitment"
          value={money(metadata?.used_commitment)}
        />

        <CommitmentsDrawerContentInfoCard
          cardSx={cardSx}
          loading={isLoading}
          title="On-demand Spend Equivalent"
          value={money(metadata?.covered_usage)}
        />

        <CommitmentsDrawerContentInfoCard
          cardSx={cardSx}
          loading={isLoading}
          title="Net Savings"
          value={money(metadata?.net_savings)}
        />
      </Stack>
    </DrawerChartHeader>
  );
};

const cardSx = { minWidth: 256, flex: 1 };
